import { Injectable } from '@angular/core';

import { GridController, TSortDirections } from '../../classes/grid-page-info';
import { FilterItems } from '../../components/filters/filter.interface';
import { IPayer, PayersFilters } from '../../interfaces/payer/payers.interface';
import { CommonGraphqlService } from '../common.graphql.service';

@Injectable({
  providedIn: 'root',
})
export class PayersStateService extends GridController<PayersFilters> {
  private _payers: IPayer[];

  private _filter: PayersFilters = {
    name: '',
    processorId: '',
    neicId: '',
    state: '',
    recordStatus: '',
  };

  payersFilters: FilterItems = {
    filtersName: 'Payers',
    items: [
      {
        name: 'name',
        caption: 'name',
        type: 'text',
        placeholder: 'Enter Name',
      },
      {
        caption: 'Processor Id',
        name: 'processorId',
        type: 'text',
        placeholder: 'Enter Processor ID',
      },
      {
        caption: 'Payer ID',
        name: 'neicId',
        type: 'text',
        placeholder: 'Enter Payer Id',
      },
      {
        caption: 'State',
        name: 'state',
        type: 'states',
        placeholder: 'Select State',
      },
      {
        name: 'recordStatus',
        type: 'checkbox',
        values: [{ text: 'Show Inactive Only', value: 'I' }],
      },
    ],
  };

  override _sortDirections: TSortDirections = {
    name: 'ASC',
    state: '',
    processorId: '',
    neicId: '',
    // ...
    // ...
    claimStatusEnrollment: '',
    recordStatus: '',
  };

  constructor(private commonGraphqlService: CommonGraphqlService) {
    super();
    this.init(this._filter, 1, 'name');
  }

  get payers(): IPayer[] {
    return this._payers;
  }

  set payers(value: IPayer[]) {
    this._payers = value;
  }
}
